import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";

export default function Register() {
  const [form, setForm] = useState({
    username: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    referralCode: "",
  });

  const [error, setError] = useState("");
  const [signupLocked, setSignupLocked] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [savedUser, setSavedUser] = useState({});
  const navigate = useNavigate();

  // ✅ Signup Lock Check
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await fetch("https://api.speedfollowinfo.com/api/settings");
        const data = await res.json();
        setSignupLocked(data.signupLock === true);
      } catch (err) {
        console.error("❌ Signup Lock Check Failed:", err);
      }
    };
    fetchSettings();
    const interval = setInterval(fetchSettings, 60000);
    return () => clearInterval(interval);
  }, []);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (signupLocked) {
      setError("🚫 Sign-up Access is currently disabled by admin.");
      return;
    }
// 🔒 PASSWORD LENGTH VALIDATION
if (form.password.length < 6) {
  setError("পাসওয়ার্ড কমপক্ষে ৬ সংখ্যার দিন 🚫");
  return;
}
    // 🔹 PHONE VALIDATION
const validPrefixes = ["017", "013", "014", "015", "016", "018", "019"];
const phone = form.phone.trim();

let isValidPhone = false;

if (phone.startsWith("+88")) {
  // +88 এর পরে 11 ডিজিট আছে কি?
  const numberPart = phone.slice(3); // +88 বাদ দিয়ে
  if (numberPart.length === 11 && validPrefixes.includes(numberPart.substring(0, 3))) {
    isValidPhone = true;
  }
} else {
  // +88 না থাকলে ১১ ডিজিট চেক
  if (phone.length === 11 && validPrefixes.includes(phone.substring(0, 3))) {
    isValidPhone = true;
  }
}

if (!isValidPhone) {
  const popup = document.createElement("div");
  popup.innerHTML = `
    <div style="
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,0.85);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 999999;
      animation: fadeIn 0.3s ease-out;
    ">
      <div style="
        background: linear-gradient(145deg,#300000,#120000);
        padding: 35px;
        width: 90%;
        max-width: 420px;
        border-radius: 18px;
        text-align: center;
        border: 2px solid #ff2e2e;
        box-shadow: 0 0 25px #ff0000;
        animation: shake 0.4s ease-out;
      ">
        <div style="font-size: 70px; margin-bottom: 10px; color:#ff2424;">
          📵
        </div>

        <h2 style="
          font-size: 24px;
          font-weight: bold;
          color: #ff4343;
          margin-bottom: 8px;
        ">
          INVALID PHONE NUMBER
        </h2>

        <p style="
          font-size: 17px;
          color: #ffb3b3;
          margin-bottom: 20px;
          line-height: 1.4;
        ">
          আপনার দেওয়া নাম্বারটি আসলে সঠিক নয়।<br/>
          ভুল নাম্বার দিয়ে একাউন্ট খোলার চেষ্টা করবেন না, সঠিক নাম্বার দিয়ে একাউন্ট খুলুন।
        </p>

        <button style="
          background: #ff0000;
          padding: 12px 20px;
          border-radius: 10px;
          border: none;
          color: white;
          font-size: 18px;
          font-weight: bold;
          cursor: pointer;
          width: 100%;
          box-shadow: 0 0 15px #ff1a1a;
        ">Try Again</button>
      </div>
    </div>

    <style>
      @keyframes fadeIn { from{opacity:0;} to{opacity:1;} }
      @keyframes shake {
        0%{ transform:translateX(0); }
        25%{ transform:translateX(-8px); }
        50%{ transform:translateX(8px); }
        75%{ transform:translateX(-5px); }
        100%{ transform:translateX(0); }
      }
    </style>
  `;
  popup.querySelector("button").onclick = () => popup.remove();
  document.body.appendChild(popup);
  return;
}

    if (form.password !== form.confirmPassword) {
  const popup = document.createElement("div");
  popup.innerHTML = `
    <div style="
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,0.85);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 999999;
      animation: fadeIn 0.3s ease-out;
    ">
      <div style="
        background: linear-gradient(145deg,#300000,#120000);
        padding: 35px;
        width: 90%;
        max-width: 420px;
        border-radius: 18px;
        text-align: center;
        border: 2px solid #ff2e2e;
        box-shadow: 0 0 25px #ff0000;
        animation: shake 0.4s ease-out;
      ">
        <div style="font-size: 70px; margin-bottom: 10px; color:#ff2424;">
          🔐
        </div>

        <h2 style="
          font-size: 26px;
          font-weight: bold;
          color: #ff4343;
          margin-bottom: 8px;
          text-shadow: 0 0 10px #ff0000;
        ">
          PASSWORD MISMATCH
        </h2>

        <p style="
          font-size: 17px;
          color: #ffb3b3;
          margin-bottom: 20px;
          line-height: 1.4;
        ">
          দুইটা Password এক না!  
          ঠিকভাবে মিলিয়ে আবার দিন ⚠️
        </p>

        <button style="
          background: #ff0000;
          padding: 12px 20px;
          border-radius: 10px;
          border: none;
          color: white;
          font-size: 18px;
          font-weight: bold;
          cursor: pointer;
          width: 100%;
          box-shadow: 0 0 15px #ff1a1a;
        ">Try Again</button>
      </div>
    </div>

    <style>
      @keyframes fadeIn { from{opacity:0;} to{opacity:1;} }
      @keyframes shake {
        0%{ transform:translateX(0); }
        25%{ transform:translateX(-8px); }
        50%{ transform:translateX(8px); }
        75%{ transform:translateX(-5px); }
        100%{ transform:translateX(0); }
      }
    </style>
  `;

  popup.querySelector("button").onclick = () => popup.remove();
  document.body.appendChild(popup);

  return;

    }

    try {
      await axios.post("https://api.speedfollowinfo.com/api/auth/register", form);

      // Save user for popup
     setSavedUser({
  username: form.username,
  email: form.email,
  phone: form.phone,   // ✅ NEW
  password: form.password,
});
      // VIP popup
      setShowSuccess(true);

      // Auto Redirect
      setTimeout(() => navigate("/login"), 7000);

    } catch (err) {

      const msg = err?.response?.data?.message || "";

     // ================================
      // ✅ Username Already Exists Popup
      // ================================
      if (msg.includes("User already exists")) {
        
        const suggested =
          form.username +
          Math.floor(Math.random() * (999 - 100 + 1) + 100);

        const popup = document.createElement("div");
        popup.innerHTML = `
          <div style="
            position: fixed;
            inset: 0;
            background: rgba(0,0,0,0.85);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 999999;
            animation: fadeIn .25s ease-out;
          ">
            <div style="
              background: linear-gradient(145deg,#1a0033,#0a0018);
              padding: 30px;
              width: 90%;
              max-width: 420px;
              border-radius: 18px;
              text-align: center;
              border: 2px solid #9b4dff;
              box-shadow: 0 0 20px #8b5cf6;
              animation: pop .45s ease-out;
            ">

              <div style="font-size: 60px; margin-bottom: 8px; color:#c084fc;">
                🙂💜
              </div>

              <h2 style="
                font-size: 24px;
                font-weight: bold;
                color: #d8b4fe;
                margin-bottom: 10px;
                text-shadow: 0 0 10px #a855f7;
              ">
                থামো ভাই! এই নামে আগেই একাউন্ট খোলা আছে 😒
              </h2>

              <p style="
                font-size: 17px;
                color: #e9d5ff;
                margin-bottom: 20px;
                line-height: 1.5;
              ">
                অন্য একটা নাম দিয়ে আবার চেষ্টা করো।<br/>
                চাইলে তুমি এ নামটাও নিতে পারো 👇
              </p>

              <div style="
                font-size: 20px;
                color: #a78bfa;
                font-weight: bold;
                background:#2a0040;
                padding:10px 0;
                border-radius:12px;
                border:1px solid #7c3aed;
                margin-bottom:18px;
              ">
                ${suggested}
              </div>

              <button style="
                background: #8b5cf6;
                padding: 12px 20px;
                border-radius: 10px;
                border: none;
                color: white;
                font-size: 18px;
                font-weight: bold;
                cursor: pointer;
                width: 100%;
                box-shadow: 0 0 12px #8b5cf6;
              ">Okay</button>
            </div>
          </div>

          <style>
            @keyframes fadeIn { from{opacity:0;} to{opacity:1;} }
            @keyframes pop {
              0% {transform:scale(0.5); opacity:0;}
              80% {transform:scale(1.15);}
              100% {transform:scale(1); opacity:1;}
            }
          </style>
        `;

        popup.querySelector("button").onclick = () => popup.remove();
        document.body.appendChild(popup);

        return;
      }

      // Default error
      setError("❌ Registration failed! Try again.");
    }
  };

  return (
    <div className="min-h-screen bg-[#0b0f1a] text-white flex flex-col lg:flex-row items-center justify-center px-6 lg:px-20 py-10">
      {/* ⭐ VIP SUCCESS POPUP (7 seconds) */}
      {showSuccess && (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center backdrop-blur-xl bg-black/60 animate-fadeIn">
          <div className="bg-white/10 backdrop-blur-2xl p-10 rounded-3xl border border-white/20 shadow-2xl text-center w-[90%] max-w-md animate-scaleIn">

            <div className="text-7xl mb-4 animate-pop">🎉</div>

            <h2 className="text-3xl font-extrabold text-[#00ffcc] drop-shadow-lg">
              Account Created Successfully
            </h2>

            <p className="mt-4 text-gray-200 text-lg leading-relaxed">
  <b className="text-[#00eaff]">📛 Username:</b> {savedUser.username} <br />

  <b className="text-[#00eaff]">🔑 Password:</b> {savedUser.password} <br />

  <b className="text-[#00eaff]">📧 Email:</b> {savedUser.email}
</p>

            <p className="mt-4 text-gray-300 text-md">
              Saving your information securely...  
              <br />
              Redirecting to Login in <b className="text-[#00ffcc]">7 seconds</b> ⏳
            </p>
          </div>

          {/* Animations */}
          <style>{`
            @keyframes fadeIn { from{opacity:0;} to{opacity:1;} }
            @keyframes scaleIn { 
              0% { transform:scale(0.7); opacity:0; } 
              100% { transform:scale(1); opacity:1; }
            }
            @keyframes pop {
              0% { transform:scale(0.5); }
              80% { transform:scale(1.2); }
              100% { transform:scale(1); }
            }
            .animate-fadeIn { animation: fadeIn .4s ease-out; }
            .animate-scaleIn { animation: scaleIn .45s ease-out; }
            .animate-pop { animation: pop .45s ease-out; }
          `}</style>
        </div>
      )}

      {/* LEFT SECTION */}
      <div className="w-full lg:w-1/2 text-center lg:text-left mb-10 lg:mb-0">
        <h1 className="text-4xl sm:text-5xl font-extrabold mb-4 leading-tight">
          <span className="text-[#8b5cf6]">Create</span>{" "}
          <span className="text-[#facc15]">Your Account</span>
        </h1>
        <h2 className="text-2xl sm:text-3xl font-bold mb-4 text-gray-100">
          Join Speed Follow Info Today
        </h2>
        <p className="text-gray-400 text-sm sm:text-base max-w-md mx-auto lg:mx-0">
          Sign up now to access the best SMM services in Bangladesh.
        </p>

        <button
          onClick={() => navigate("/login")}
          className="mt-6 bg-gradient-to-r from-[#8b5cf6] to-[#4f46e5] px-6 py-3 rounded-lg font-semibold hover:opacity-90 transition"
        >
          Back To Login
        </button>
      </div>

      {/* FORM */}
      <div className="w-full lg:w-1/2 max-w-md bg-[#161c34] p-8 rounded-2xl shadow-2xl">
        <h2 className="text-3xl font-bold text-center text-[#facc15] mb-6">
          Create Your Account
        </h2>

        {signupLocked && (
          <p className="text-red-400 text-sm text-center mb-3 bg-red-900/20 py-2 rounded-lg">
            🚫 Sign-up Access is currently disabled by admin.
          </p>
        )}

        {error && !signupLocked && (
          <p className="text-red-400 text-sm text-center mb-3 bg-red-900/20 py-2 rounded-lg">
            {error}
          </p>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Username */}
          <div>
            <label className="block text-gray-300 mb-1">Username</label>
            <input
              type="text"
              name="username"
              required
              disabled={signupLocked}
              value={form.username}
              onChange={handleChange}
              placeholder="Enter your username"
              className="w-full bg-[#1b2142] text-white border border-[#2f3b6c] rounded-lg p-3"
            />
          </div>

          {/* Email */}
          <div>
            <label className="block text-gray-300 mb-1">Email Address</label>
            <input
              type="email"
              name="email"
              required
              disabled={signupLocked}
              value={form.email}
              onChange={handleChange}
              placeholder="Enter your email"
              className="w-full bg-[#1b2142] text-white border border-[#2f3b6c] rounded-lg p-3"
            />
          </div>
          {/* Phone Number */}
<div>
  <label className="block text-gray-300 mb-1">
  Phone Number (WhatsApp)
  <span className="ml-2 text-xs text-green-400 font-semibold">
    অবশ্যই রানিং নাম্বার দিবেন ✅
  </span>
</label>
  <input
    type="tel"
    name="phone"
    required
    disabled={signupLocked}
    value={form.phone}
    onChange={handleChange}
    placeholder="Enter WhatsApp number"
    className="w-full bg-[#1b2142] text-white border border-[#2f3b6c] rounded-lg p-3"
  />
</div>

          {/* Password */}
          <div>
            <label className="block text-gray-300 mb-1">Password</label>
            <input
              type="password"
              name="password"
              required
              disabled={signupLocked}
              value={form.password}
              onChange={handleChange}
              placeholder="Enter password"
              className="w-full bg-[#1b2142] text-white border border-[#2f3b6c] rounded-lg p-3"
            />
          </div>

          {/* Confirm Password */}
          <div>
            <label className="block text-gray-300 mb-1">Confirm Password</label>
            <input
              type="password"
              name="confirmPassword"
              required
              disabled={signupLocked}
              value={form.confirmPassword}
              onChange={handleChange}
              placeholder="Re-enter password"
              className="w-full bg-[#1b2142] text-white border border-[#2f3b6c] rounded-lg p-3"
            />
          </div>
        {/* Reference Code (Optional) */}
<div>
  <label className="block text-gray-300 mb-1">
    Reference Code
    <span className="ml-2 text-xs text-green-400 font-semibold">
      যদি কেউ আপনাকে refer করে ✅
    </span>
  </label>
  <input
    type="text"
    name="referralCode"
    disabled={signupLocked}
    value={form.referralCode}
    onChange={handleChange}
    placeholder="Enter referral code (Optional)"
    className="w-full bg-[#1b2142] text-white border border-[#2f3b6c] rounded-lg p-3"
  />
</div>
          <button
            type="submit"
            disabled={signupLocked}
            className="w-full py-3 rounded-lg font-semibold bg-gradient-to-r from-green-500 to-emerald-600 hover:opacity-90 transition"
          >
            {signupLocked ? "Sign-up Disabled" : "Create Account"}
          </button>
        </form>

        <div className="text-center mt-4 text-gray-400 text-sm">
          Already have an account?{" "}
          <Link to="/login" className="text-[#facc15] font-semibold hover:underline">
            Login here
          </Link>
        </div>
      </div>
    </div>
  );
}